import { Component, Input } from '@angular/core';

import { ErrorInterface } from '../../core';

@Component({
    selector: 'solis-list-errors',
    templateUrl: './list-errors.component.html',
})
export class ListErrorsComponent {
    formattedErrors: Array<any> = [];

    @Input()
    set errors(errorsList: ErrorInterface[]) {
        if (errorsList.length > 0) {
            errorsList.map(errorList => {
                if (errorList.message.error) {
                    this.formattedErrors = [
                        { message: errorList.message.error },
                    ];
                } else {
                    this.formattedErrors = errorList.message.errors;
                }
            });
        } else {
            this.formattedErrors = [];
        }
    }

    get errorsList() {
        return this.formattedErrors;
    }
}
